<div class="card incidencia-seguridad-ticket-modal">
  <div class="card-header card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h4 class="card-title"><b>{{ titulo }}</b></h4>
        <p class="card-category" *ngIf="muestraApertura">
          Registra la incidencia de seguridad. La fecha de apertura y el usuario se asignan automáticamente.
        </p>
        <p class="card-category" *ngIf="muestraSeguimiento">
          Complementa la atención, los 5 porqués y las observaciones del ticket.
        </p>
      </div>
      <div class="col-sm-12 col-md-1 text-right">
        <button mat-icon-button type="button" aria-label="Cerrar" (click)="cancelar()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body" [class.incidencia-seguridad-ticket-modal__body--seguimiento]="muestraSeguimiento">
    <div class="wraper">
      <div class="container">
        <div class="alert alert-danger incidencia-seguridad-ticket-modal__alert" *ngIf="error">
          <i class="material-icons">error_outline</i>
          <span>{{ error }}</span>
        </div>

        <div class="alert alert-warning incidencia-seguridad-ticket-modal__alert" *ngIf="advertencia">
          <i class="material-icons">warning_amber</i>
          <span>{{ advertencia }}</span>
        </div>

        <div class="alert alert-success incidencia-seguridad-ticket-modal__alert" *ngIf="mensajeExito">
          <i class="material-icons">check_circle</i>
          <span>{{ mensajeExito }}</span>
        </div>

        <div class="text-center text-muted my-4" *ngIf="cargando">
          <i class="material-icons">hourglass_top</i>
          <strong>Cargando...</strong>
        </div>

        <form #form="ngForm" novalidate (ngSubmit)="guardar()" *ngIf="!cargando">
          <div class="row incidencia-seguridad-ticket-modal__opening-layout" *ngIf="muestraApertura">
            <div class="col-sm-12 col-lg-7 border-right incidencia-seguridad-ticket-modal__opening-main">
              <div class="col-sm-12">
                <mat-form-field>
                  <input matInput placeholder="Proceso / procedimiento afectado" aria-label="Proceso / procedimiento afectado" maxlength="90"
                    [(ngModel)]="incidencia.procesoProcedimientoAfectado" name="procesoProcedimientoAfectado" required />
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <textarea matInput placeholder="Descripción" aria-label="Descripción" rows="5" maxlength="500"
                    [(ngModel)]="incidencia.descripcionEvento" name="descripcionEvento" required></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-12 col-lg-5 incidencia-seguridad-ticket-modal__opening-side">
              <div class="row">
                <div class="col-sm-6">
                  <div class="incidencia-seguridad-field-with-hint">
                    <mat-form-field>
                      <mat-select [(ngModel)]="incidencia.gravedad" name="gravedad" required>
                        <mat-option *ngFor="let option of gravedadOptions" [value]="option.value" [matTooltip]="option.description || ''">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                      <mat-label><b>Gravedad</b></mat-label>
                    </mat-form-field>
                    <p class="incidencia-seguridad-ticket-modal__hint" *ngIf="getDescripcionGravedad()">
                      {{ getDescripcionGravedad() }}
                    </p>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="incidencia-seguridad-field-with-hint">
                    <mat-form-field>
                      <mat-select [(ngModel)]="incidencia.prioridad" name="prioridad" required>
                        <mat-option *ngFor="let option of prioridadOptions" [value]="option.value" [matTooltip]="option.description || ''">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                      <mat-label><b>Prioridad</b></mat-label>
                    </mat-form-field>
                    <p class="incidencia-seguridad-ticket-modal__hint" *ngIf="getDescripcionPrioridad()">
                      {{ getDescripcionPrioridad() }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <mat-select [(ngModel)]="incidencia.tipoIncidencia" name="tipoIncidencia" required>
                    <mat-option *ngFor="let option of tipoEventoOptions" [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  </mat-select>
                  <mat-label><b>Tipo</b></mat-label>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row incidencia-seguridad-process-layout" *ngIf="muestraSeguimiento">
            <div class="col-sm-6 border-right incidencia-seguridad-process-layout__main">
              <div class="col-sm-12" *ngIf="incidencia.responsableResolucion">
                <div class="incidencia-seguridad-ticket-modal__assigned">
                  <span>Responsable de resolución</span>
                  <strong>{{ incidencia.responsableResolucion }}</strong>
                  <small>{{ incidencia.responsableResolucionPerfil || incidencia.responsableResolucionCargo }}</small>
                </div>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <mat-label><b>Fecha planeada de resolución</b></mat-label>
                  <input matInput aria-label="Fecha planeada de resolución" [matDatepicker]="pickerPlaneada" [min]="minFechaPlaneada"
                    [(ngModel)]="incidencia.fechaPlaneadaResolucion" name="fechaPlaneadaResolucion"
                    [disabled]="soloLecturaCampos" required />
                  <mat-datepicker-toggle matSuffix [for]="pickerPlaneada" [disabled]="soloLecturaCampos"></mat-datepicker-toggle>
                  <mat-datepicker #pickerPlaneada></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <textarea matInput placeholder="Acción correctiva" aria-label="Acción correctiva" rows="5" maxlength="500"
                    [(ngModel)]="incidencia.accionCorrectiva" name="accionCorrectiva" [disabled]="soloLecturaCampos" required></textarea>
                </mat-form-field>
              </div>

              <div class="col-sm-12">
                <div class="incidencia-seguridad-field-with-hint">
                  <mat-form-field>
                    <mat-select [(ngModel)]="incidencia.tipoSolucion" name="tipoSolucion" [disabled]="soloLecturaCampos" required>
                      <mat-option *ngFor="let option of tipoSolucionOptions" [value]="option.value" [matTooltip]="option.description || ''">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
                    <mat-label><b>Tipo de solución</b></mat-label>
                  </mat-form-field>
                  <p class="incidencia-seguridad-ticket-modal__hint" *ngIf="getDescripcionTipoSolucion()">
                    {{ getDescripcionTipoSolucion() }}
                  </p>
                </div>
              </div>

              <div class="col-sm-12">
                <mat-form-field>
                  <mat-label><b>Responsable de seguimiento</b></mat-label>
                  <mat-select [(ngModel)]="incidencia.idEmpleadoResponsableSeguimiento" name="idEmpleadoResponsableSeguimiento" [disabled]="soloLecturaCampos" (selectionChange)="onResponsableSeguimientoChange()">
                    <mat-option *ngFor="let responsable of responsables" [value]="responsable.idEmpleado">
                      {{ responsable.nombreCompleto || responsable.usuario?.nombrePersona || responsable.usuario?.user_nom }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-6 incidencia-seguridad-process-layout__side">
              <div class="incidencia-seguridad-panel" [class.is-open]="panelDerecho === 'observaciones'">
                <button type="button" class="incidencia-seguridad-panel__header" (click)="abrirPanelDerecho('observaciones')">
                  <span>Observaciones</span>
                  <i class="material-icons">expand_more</i>
                </button>
                <div class="incidencia-seguridad-panel__body" *ngIf="panelDerecho === 'observaciones'">
                  <div class="incidencia-seguridad-comments" *ngIf="comentarios.length; else sinComentarios">
                    <div class="incidencia-seguridad-comment" *ngFor="let comentario of comentarios; trackBy: trackByComentario">
                      <div class="incidencia-seguridad-comment__meta">
                        <strong>{{ comentario.nombreUsuario || "Usuario" }}</strong>
                        <span>{{ comentario.fechaComentario ? (comentario.fechaComentario | date: "dd/MM/yyyy HH:mm") : "-" }}</span>
                      </div>
                      <p>{{ comentario.comentario }}</p>
                    </div>
                  </div>
                  <ng-template #sinComentarios>
                    <div class="incidencia-seguridad-comments__empty">Sin comentarios registrados.</div>
                  </ng-template>

                  <mat-form-field>
                    <textarea matInput placeholder="Agregar comentario" aria-label="Agregar comentario" rows="4" maxlength="500"
                      [(ngModel)]="nuevoComentario" name="nuevoComentario" [disabled]="soloConsulta"></textarea>
                  </mat-form-field>
                </div>
              </div>

              <div class="incidencia-seguridad-panel" [class.is-open]="panelDerecho === 'porques'">
                <button type="button" class="incidencia-seguridad-panel__header" (click)="abrirPanelDerecho('porques')">
                  <span>Causa / Origen</span>
                  <i class="material-icons">expand_more</i>
                </button>
                <div class="incidencia-seguridad-panel__body" *ngIf="panelDerecho === 'porques'">
                  <div class="incidencia-seguridad-porques">
                    <div class="incidencia-seguridad-porques__header">
                      <div>
                        <strong>Causa / Origen</strong>
                        <p>Los primeros cinco son obligatorios; puedes agregar más si aplica.</p>
                      </div>
                      <button mat-icon-button type="button" class="incidencia-seguridad-porques__info" (click)="abrirInformacionCausaOrigen()">
                        <mat-icon>info</mat-icon>
                      </button>
                      <button mat-button type="button" class="btn btn-info btn-sm" (click)="agregarPorque()" [disabled]="soloLecturaCampos">
                        Agregar porqué <i class="material-icons">add</i>
                      </button>
                    </div>

                    <div class="incidencia-seguridad-porques__scroll">
                      <div class="incidencia-seguridad-porque" *ngFor="let porque of porques; let i = index; trackBy: trackByPorque">
                        <div class="incidencia-seguridad-porque__question">
                          <span>{{ i + 1 }}</span>
                          <strong>{{ preguntaPorque(i) }}</strong>
                          <button mat-icon-button type="button" *ngIf="i >= 5" (click)="eliminarPorque(i)" [disabled]="soloLecturaCampos">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                        <mat-form-field>
                          <input matInput [placeholder]="'Respuesta ' + (i + 1)" [attr.aria-label]="'Respuesta ' + (i + 1)" maxlength="100"
                            [(ngModel)]="porques[i]" [name]="'porque' + i" [disabled]="soloLecturaCampos" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="col-sm-6 border-right ml-auto">
            <div mat-dialog-actions class="justify-content-end">
              <button mat-button class="btn btn-danger" type="button" (click)="cancelar()">
                <i class="fa fa-times-circle-o"></i> Cancelar
              </button>
              <button mat-button type="button" (click)="guardar()" class="btn btn-success" [disabled]="guardando || cargando || soloConsulta">
                {{ textoBotonGuardar }} <i class="material-icons">save</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
